import styled from 'styled-components';
import { LayoutContent, Layout } from '@/ui';
import { COLORS } from '@/theme';

// TODO: For demo purposes only. Remove afterwards!

export const StyledContent = styled(LayoutContent)`
  width: 100%;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledLayoutWrapper = styled(Layout)`
  width: 100%;
  height: 100%;
  display: flex;
  margin-left: 18rem;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  background-color: ${COLORS.WHITE};

  @media print {
    margin-left: 0 !important;
  }
`;
